/** Situações dos recursos de campanhas */
export interface RecursoCampanhaSituacao {
    id: number;
    nome: string;
}

export const recursoCampanhaSituacaoAtivo: RecursoCampanhaSituacao = {id: 1, nome: 'Ativo'};
export const recursoCampanhaSituacaoInativo: RecursoCampanhaSituacao = {id: 2, nome: 'Inativo'};

export const recursoCampanhaSituacoes: RecursoCampanhaSituacao[] = [
    recursoCampanhaSituacaoAtivo,
    recursoCampanhaSituacaoInativo
];

/** Verifica se a situação informada é igual a Ativo */
export function isSituacaoAtivo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === recursoCampanhaSituacaoAtivo.id;
}

/** Verifica se a situação informada é igual a Inativo */
export function isSituacaoInativo(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === recursoCampanhaSituacaoInativo.id;
}
